import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login/Login';
import ForgotPassword from './components/Login/ForgotPassword';
import AddMobile from './components/Login/AddMobile';
import Home from './components/Home/Home';
import PizzaListing from './components/PizzaListing/PizzaListing';
import RestaurantDetail from './components/RestaurantDetail/RestaurantDetail';
import Checkout from './components/Checkout/Checkout';
import Payment from './components/Payment/Payment';
import OrderSuccess from './components/OrderSuccess/OrderSuccess';
import OrderTracking from './components/OrderTracking/OrderTracking';
import LiveTracking from './components/LiveTracking/LiveTracking';
import OrderDetails from './components/OrderDetails/OrderDetails';
import Profile from './components/Profile/Profile';
import ChangePassword from './components/Profile/ChangePassword';
import Addresses from './components/Profile/Addresses';
import PaymentMethods from './components/Profile/PaymentMethods';
import Refunds from './components/Profile/Refunds';
import Favorites from './components/Profile/Favorites';
import Wallet from './components/Wallet/Wallet';
import FAQ from './components/Support/FAQ';
import ContactSupport from './components/Support/ContactSupport';
import PolicyPage from './components/Support/PolicyPage';
import Coupons from './components/Profile/Coupons';
import NotificationsPage from './components/Profile/NotificationsPage';

import './App.css';
import ErrorBoundary from './ErrorBoundary';
import ScrollToTop from './ScrollToTop';
import Register from './components/Register/Register';
import Splash from './components/Froentpage/Splash';
import Language from './components/Froentpage/Language';
import Intro from './components/Froentpage/Intro';
import SearchPage from './components/RestaurantDetail/SearchPage';
import { LanguageProvider } from './context/LanguageContext';
import { CountryProvider } from './context/CountryContext';
import { NotificationProvider } from './context/NotificationContext';
import { getSessionToken } from './utils/authSession';

function AppContent() {

  const location = useLocation();
  useEffect(() => {
    const lang = localStorage.getItem("language") || "en";
    document.body.dir = lang === "ar" ? "rtl" : "ltr";
  }, []);
  const [isAuthenticated, setIsAuthenticatedState] = useState(() => {
    try {
      const hasAuth = localStorage.getItem('waseeny_isAuthenticated') === 'true';
      const hasToken = Boolean(getSessionToken());
      return hasAuth && hasToken;
    } catch (e) {
      return false;
    }
  });

  // wrapper to persist auth state
  const setIsAuthenticated = (value) => {
    try {
      localStorage.setItem('waseeny_isAuthenticated', value ? 'true' : 'false');
    } catch (e) {
      // ignore storage errors
    }
    setIsAuthenticatedState(value);
  };

  return (
    <div className="App">
      <ScrollToTop />
      <ErrorBoundary>
        <Routes>
          {/*  Splash */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/*  Flow pages */}
          <Route path="/language" element={<Language />} />
          <Route path="/intro" element={<Intro />} />

          {/*  Auth pages */}
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/add-mobile" element={<AddMobile setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<Register setIsAuthenticated={setIsAuthenticated} />} />

          {/*  Routes accessible to guests */}
          <Route path="/home" element={<Home isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/pizza" element={<PizzaListing />} />
          <Route path="/restaurant/:id" element={<RestaurantDetail />} />

          {/*  Protected routes (Login required) */}
          <Route path="/checkout" element={isAuthenticated ? <Checkout /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/payment" element={isAuthenticated ? <Payment /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/order-success" element={isAuthenticated ? <OrderSuccess /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/order-tracking" element={isAuthenticated ? <OrderTracking /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/live-tracking/:id" element={isAuthenticated ? <LiveTracking /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/order-details/:id" element={isAuthenticated ? <OrderDetails /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/change-password" element={isAuthenticated ? <ChangePassword /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/addresses" element={isAuthenticated ? <Addresses /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/payment-methods" element={isAuthenticated ? <PaymentMethods /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/refunds" element={isAuthenticated ? <Refunds /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/favorites" element={isAuthenticated ? <Favorites /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/wallet" element={isAuthenticated ? <Wallet /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/faq" element={isAuthenticated ? <FAQ /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/contact-support" element={isAuthenticated ? <ContactSupport /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/privacy-policy" element={<PolicyPage />} />
          <Route path="/terms" element={<PolicyPage />} />
          <Route path="/about-us" element={<PolicyPage />} />
          <Route path="/coupons" element={isAuthenticated ? <Coupons /> : <Navigate to="/login" state={{ from: location }} replace />} />
          <Route path="/notifications" element={isAuthenticated ? <NotificationsPage /> : <Navigate to="/login" state={{ from: location }} replace />} />

        </Routes>
      </ErrorBoundary>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <CountryProvider>
        <NotificationProvider>
          <Router>
            <AppContent />
          </Router>
        </NotificationProvider>
      </CountryProvider>
    </LanguageProvider>
  );
}


export default App;
